// extracted by mini-css-extract-plugin
export default {"messengerIsOpen":"KLO07wxGJR"};